<!--
    描述：人员管理--右侧组织架构
    时间：2020-04-22
    Created by zwh
-->
<template>
    <div class="h100">
        <div class="w-table-layout">
            <div class="w-table-content" ref="menusContent">
                <el-tree :data="rolesTreeData.treeData" :props="defaultProps" @node-click="handleNodeClick" :expand-on-click-node="false" :highlight-current="true" default-expand-all></el-tree>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {selectTree} from 'api/modules/role.js'

    export default {
        components: {},
        data() {
            return {
                btnLoading: false,
                dialogObj: {
                    title: '',
                    visible: false,
                    width: '650px',
                    mode: 'add',
                },
                rolesTreeData: {
                    loading: false,
                    tableH: 200,
                    treeData: []
                },
                defaultProps: {
                    children: 'children',
                    label: 'roleName'
                },

                clickNode : {
                    id : '',
                    roleName : '',
                },

            }
        },
        methods: {
            getTreeData(){
                let param = {};
                selectTree(param).then(res => {
                    this.rolesTreeData.treeData = res.data;
                });
            },
            handleNodeClick(e){
                this.clickNode.id = e.id
                this.clickNode.roleName = e.roleName

                this.$emit('handle-select-parent-menu', this.clickNode)
            },
        },
        created() {
            this.getTreeData();
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.rolesTreeData.tableH = this.$refs.menusContent.offsetHeight;
                }, 100)
            })
        },
        computed: {
            ...mapState('app', {clientSize: state => state.clientSize})
        },
        watch: {
            clientSize(val) {
                this.rolesTreeData.tableH = this.$refs.menusContent.offsetHeight;
            }
        }
    }
</script>
<style lang="less">

</style>
